
import { NgModule } from '@angular/core';
import { PrivacyComponent } from './privacy/privacy.component';
import { TosComponent } from './tos/tos.component';


const COMPONENTS = [
    PrivacyComponent,
    TosComponent
];

@NgModule({
    declarations: COMPONENTS,
    exports: COMPONENTS
})
export class RegulationsModule { }
